import { render, staticRenderFns } from "./RegistrationView.vue?vue&type=template&id=d6c9b41c&scoped=true&"
import script from "./RegistrationView.vue?vue&type=script&lang=js&"
export * from "./RegistrationView.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationView.vue?vue&type=style&index=0&id=d6c9b41c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c9b41c",
  null
  
)

export default component.exports